import { useParams } from "react-router-dom";
import SliderProject from "../sliderProject/SliderProject";
import "./BriefProject.css";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useRecoilState } from "recoil";
import { $ServerUrl } from "../../store";
export default function BriefProject() {
  const [serverUrl] = useRecoilState($ServerUrl);
  // const parms = useParams();
  // const projectId = parms.projectId;
  const [project, setProject] = useState({});
const {projectId} = useParams()


const baseUrl = "https://dashboard.abaadre.com/storage/";
const imageUrls = useMemo(() => {
  console.log(project.images?.map(img => `${baseUrl}${img.image_path}`));
  
  return project.images?.map(img => `${baseUrl}${img.image_path}`) || [];
}, [project]);  
// function getProjectDetails() {
  //   let server = `${serverUrl}/projects/${projectId}`;
  //   axios
  //     .get(server, {
  //       params: {
  //         populate: {
  //           project_features: {
  //             populate: "*",
  //           },
  //           project_photos: {
  //             populate: "*",
  //           },
  //         },
  //       },
  //     })
  //     .then((res) => {
  //       console.log(res.data.data.attributes);
  //       setProject(res.data.data.attributes);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }
const fetchData = async () => {
  try {
    const res = await axios.get(`https://dashboard.abaadre.com/api/projects/${projectId}`);
    setProject(res.data);
console.log("Whole response:", res.data);

    

  } catch (error) {
    console.log(error);
    
  }
}
  useEffect(() => {
    fetchData();
    // getProjectDetails();
  }, []);

  return (
    <>
      <div className="brief-project container">
        <div className="left-section-brief-project">
        <h1 className="head-text-section-2 des">
            مشروع
            <span className="your-choose"> {project.title} </span>
          </h1>
          <p className="brief-short brief-short-tab">
            {project.slogan
              ? project.slogan
              : `بنفخر بتقديم تجربة عملاء راضين وشهادات نجاح ملهمة بتعكس جودة خدماتنا
            وتقديم حلول مبتكرة`}
          </p>
          <SliderProject
            imgs={imageUrls}
          />
          <div className="desc-brief-project">
            <h1 className="general-overview">وصف</h1>
            <p className="brief-short color-text2">
              {project.description}
            </p>




          </div>
        </div>
        <div className="right-section-brief-project">
          <h1 className="head-text-section-2 dess">
            مشروع
            <span className="your-choose"> {project.title} </span>
          </h1>
          <p className="brief-short brief-short-pc">
            {project.slogan
              ? project.slogan
              : `بنفخر بتقديم تجربة عملاء راضين وشهادات نجاح ملهمة بتعكس جودة خدماتنا
            وتقديم حلول مبتكرة`}
          </p>
          <div className="container-details-project">
            <h1 className="general-overview">نظرة عامة</h1>
            <div className="container-feoture display-card2">
              <p className="color-text2">تبدأ من {project.price} </p>
              <p className="color-text2 head-price">السعر </p>
            </div>
            <div className="container-feoture display-card2">
              <p className="color-text2"> تبدأ من {project.area}م</p>
              <p className="color-text2 head-price">المساحات</p>
            </div>
            <div className="container-feoture display-card2">
              <p className="color-text2"> تبدأ من {project.rooms_count} </p>
              <p className="color-text2 head-price">الغرف</p>
            </div>
            <div className="container-feoture display-card2">
              <p className="color-text2"> تبدأ من {project.halls_count} </p>
              <p className="color-text2 head-price">الصالة</p>
            </div>
            <div className="container-feoture display-card2">
              <p className="color-text2"> تبدأ من {project.bathrooms_count} </p>
              <p className="color-text2 head-price">عدد دورات المياه</p>
            </div>
            <div className="container-feoture display-card2">
              <p className="color-text2"> تبدأ من {project.kitchens_count} </p>
              <p className="color-text2 head-price">مطبخ</p>
            </div>
            <hr className="container" />
            <h1 className="general-overview">المزايا</h1>
            {project.project_features ? (
              <div className="container-features">
                {project.project_features.data.map((feature , i) => {
                  return (
                    <div
                    key={i}
                      className="contaner-image-features"
                    >
                     
                      <img
                        className="col-12"
                        
                  
                        src={serverUrl.split("/api")[0]+feature.attributes.feature_icon.data.attributes.url}
                        />
                 
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
        </div>





      </div>
    </>
  );
}
